import { FC } from 'react';

import { IconProps } from './types';

export const SmallCheckIcon: FC<IconProps> = ({
	color = '#06519E',
	height = 24,
	size,
	width = 24,
}) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 24 24"
		width={size ?? width}
		height={size ?? height}
	>
		<path
			fill={color}
			fill-rule="evenodd"
			d="M10.293 14.707a.997.997 0 0 0 1.414 0l4-4a.999.999 0 1 0-1.414-1.414L11 12.586l-1.293-1.293a.999.999 0 1 0-1.414 1.414z"
		/>
	</svg>
);
